module.exports = __webpack_public_path__ + "img/znlyjkxt2.8fca26af.jpg";